module.exports = __webpack_public_path__ + "img/demo-booking-left-info.2e09b1a5.png";